import { useState, useEffect } from "react"
import api from '../../../utils/api'

/* form */
import Input from "../../../shared/components/form/input"
import Radio from "../../../shared/components/form/Radio"
import Select from 'react-select'
import selectStyles from "../../../shared/css/SelectStyle"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Button from "../../../shared/components/Button/Button"

const UNIT_OPTIONS = [
    { selectName: "unit", value: "m", label: "Metro" },
    { selectName: "unit", value: "kg", label: "Quilo" },
]

const MATERIAL_TYPE_OPTIONS = [
    { value: "cloth", label: "Tecido" },
    { value: "aviamento", label: "Aviamento" },
]

const ORIGIN_OPTIONS = [
    { value: "comprado", label: "Comprado agora" },
    { value: "sobra", label: "Sobra reaproveitada" },
]

function FormStockLot({ handleSubmit, title, btnText, btCancelAction, initialLot }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const [lot, setLot] = useState(initialLot || { materialType: "cloth", origin: "comprado", entryDate: new Date().toISOString().slice(0, 10) })

    const [cloths, setCloths] = useState([])
    const [providers, setProviders] = useState([])
    const [aviamentos, setAviamentos] = useState([])

    useEffect(() => {
        api.get('/product/getInfoSelect', {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` }
        }).then((response) => {
            setCloths(response.data.cloths)
            setProviders(response.data.providers)
        })
        api.get('/aviamento/getall', {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` }
        }).then((response) => {
            setAviamentos(response.data.aviamentos)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])

    function handleChange(e) {
        setLot({ ...lot, [e.target.name]: e.target.value })
    }

    function handleSelectChange(selectedOption) {
        setLot({ ...lot, [selectedOption.selectName]: selectedOption })
    }

    function handleChangeRadio(name, value) {
        setLot({ ...lot, [name]: value })
    }

    function handleChangeMaterialType(name, value) {
        // Trocar de tipo de material invalida as seleções de tecido/aviamento/unidade feitas antes.
        setLot({ ...lot, materialType: value, cloth: undefined, aviamento: undefined, unit: undefined })
    }

    function handleSelectAviamento(selectedAviamento) {
        // Unidade é fixa no cadastro do Aviamento — não é uma escolha livre igual em Tecido.
        setLot({ ...lot, aviamento: selectedAviamento, unit: selectedAviamento.unit })
    }

    function submit(e) {
        e.preventDefault()
        handleSubmit(lot)
    }

    const isAviamento = lot.materialType === "aviamento"

    return (
        <FormLayout
            title={title}
            onSubmit={submit}
            actions={
                <>
                    <Button variant="save" type="submit">{btnText || 'Salvar'}</Button>
                    {btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>}
                </>
            }
        >
            <FormSection label="Material">
                <div className="form-group">
                    <Radio
                        options={MATERIAL_TYPE_OPTIONS}
                        name="materialType"
                        value={lot.materialType}
                        defaultValue="cloth"
                        handleOnChange={handleChangeMaterialType}
                    />
                </div>

                {isAviamento ? (
                    <div className="fl-row">
                        <div className="fl-col-mid form-group">
                            <label className="input-label">Aviamento:</label>
                            <Select
                                options={aviamentos}
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item._id}
                                styles={selectStyles}
                                onChange={handleSelectAviamento}
                                value={lot.aviamento || ""}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                            />
                        </div>
                        <div className="fl-col-mid form-group">
                            <label className="input-label">Fornecedor <span className="fl-section-optional">(opcional)</span>:</label>
                            <Select
                                options={providers}
                                styles={selectStyles}
                                onChange={handleSelectChange}
                                value={lot.provider || ""}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                            />
                        </div>
                        <div className="fl-col-mid form-group">
                            <Input text="Unidade" type="text" name="unitLabel" value={lot.unit?.label || lot.unit?.value || ''} handleOnChange={() => {}} disabled />
                        </div>
                    </div>
                ) : (
                    <div className="fl-row">
                        <div className="fl-col-mid form-group">
                            <label className="input-label">Tecido:</label>
                            <Select
                                options={cloths}
                                styles={selectStyles}
                                onChange={handleSelectChange}
                                value={lot.cloth || ""}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                            />
                        </div>
                        <div className="fl-col-mid form-group">
                            <label className="input-label">Fornecedor:</label>
                            <Select
                                options={providers}
                                styles={selectStyles}
                                onChange={handleSelectChange}
                                value={lot.provider || ""}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                            />
                        </div>
                        <div className="fl-col-mid form-group">
                            <label className="input-label">Unidade:</label>
                            <Select
                                options={UNIT_OPTIONS}
                                styles={selectStyles}
                                onChange={handleSelectChange}
                                value={lot.unit || ""}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                            />
                        </div>
                    </div>
                )}

                <div className="fl-row">
                    <div className="fl-col-mid form-group">
                        <Input text="Quantidade" type="number" name="originalQuantity" placeholder="0.00" handleOnChange={handleChange} value={lot.originalQuantity || ''} />
                    </div>
                    <div className="fl-col-mid form-group">
                        <Input text="Custo Unitário (R$)" type="number" name="unitCost" placeholder="0.00" handleOnChange={handleChange} value={lot.unitCost || ''} />
                    </div>
                    <div className="fl-col-mid form-group">
                        <Input text="Data de Entrada" type="date" name="entryDate" handleOnChange={handleChange} value={lot.entryDate || ''} />
                    </div>
                </div>
            </FormSection>

            <FormSection label="Origem do Lote">
                <div className="form-group">
                    <Radio
                        options={ORIGIN_OPTIONS}
                        name="origin"
                        value={lot.origin}
                        defaultValue="comprado"
                        handleOnChange={handleChangeRadio}
                    />
                </div>

                {lot.origin === "sobra" && (
                    <div className="form-group">
                        <Input text="Referência (ex.: Pedido #12)" type="text" name="originReference" placeholder="De onde essa sobra veio" handleOnChange={handleChange} value={lot.originReference || ''} />
                    </div>
                )}

                <div className="form-group">
                    <Input text="Observação" type="text" name="obs" placeholder="Observações sobre o lote" handleOnChange={handleChange} value={lot.obs || ''} />
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormStockLot
